<template>
  <div class="col-md-8" style="padding: 0!important;">
    <div class="col-md-6 ">
      <datepicker class="form-control datepicker col-md-6" :value="begin.value" v-model="begin.value" :name="begin.name" :required="begin.required" placeholder="année-mois-jour" @selected="selectedBegin" format="yyyy-MM-dd" full-month-name monday-first></datepicker>
    </div>
    <div class="col-md-6 xsMargin">
      <datepicker class="form-control datepicker col-md-6" :value="end.value" v-model="end.value" :name="end.name" :required="end.required" placeholder="année-mois-jour" :disabledDates="end.disabledDates" format="yyyy-MM-dd" full-month-name monday-first></datepicker>
    </div>
  </div>
</template>

<style>
  .datepicker input {
    width: 98%;
    border: 0px solid #000;
  }
  @media (max-width: 480px) {
    .xsMargin {
      margin-top : 10px;
    }
  }
</style>

<script>
  import Datepicker from 'vuejs-datepicker'
  export default {
    name:'inputDatePeriod',
    props:['beginname','beginvalue','beginrequired','endname','endvalue','endrequired'],
    data() {
      return {
        begin: {
          name: this.beginname,
          required: this.beginrequired,
          value: this.beginvalue
        },
        end: {
          name: this.endname,
          required: this.endrequired,
          value: this.endvalue,
          disabledDates: {
            to: new Date(this.beginvalue)
          }
        }
      }
    },
    methods: {
      selectedBegin(value) {
        this.begin.value=value;
        this.end.disabledDates.to=value;
      }
    },
    components: {
      Datepicker
    }
  }
</script>